"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.alertsAPI = void 0;
const createApi_1 = require("../../helpers/createApi");
const schemas_1 = require("./schemas");
const getAlerts = (caller) => async ({ accountId, accountIds }) => {
    const response = await caller(`/accounts/${accountId}/alerts`).get({
        account_ids: accountIds,
    });
    schemas_1.alertsCardSchema.parse(response);
    return response;
};
const acknowledgeAlerts = (caller) => async ({ accountId, alertId }) => {
    return caller(`/accounts/${accountId}/alerts/${alertId}`).patch({
        acknowledge: true,
    });
};
exports.alertsAPI = (0, createApi_1.createAPIFactory)({
    list: getAlerts,
    acknowledge: acknowledgeAlerts,
});
//# sourceMappingURL=api.js.map